// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tq-2";
export var chatLink = "_tq-0";
export var chatText = "_tq-1";